import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EditableQuestion, LstQuestionValueDataView, Question, Section } from '../model/inaSchoolEnrollments';
import { INAAction } from '../../model/ina-action';
import { InaService } from '../../service/ina.service';
import { Shared } from '../../service/shared';
import { StepAction } from '../model/stepAction';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { User } from 'src/app/component/auth/model/user.model';
import { formatDate } from '@angular/common';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-created-by-follow-up',
  templateUrl: './created-by-follow-up.component.html',
  styleUrls: ['./created-by-follow-up.component.scss']
})



export class CreatedByFollowUpComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;

  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  editing: boolean = true;
  frmCreatedByFollow: UntypedFormGroup;

  inaStatusTypeId: number;
  section: Section;
  shared: Shared;
  notifyAction: string = '';
  dataChanged: boolean = false;
  totalCommentQuestion: number;

  commentEditableQuestions: EditableQuestion[] = []; //outgoing, Send data to child component
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();
  constructor(
    private fb: FormBuilder,
    private inaService: InaService,
    private loginTokenService: LoginTokenService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];

    this.frmCreatedByFollow = this.fb.group({
      fName: ['', Validators.required],
      lName: ['', Validators.required],
      createdDate: ['', Validators.required],
      updatedFName: ['', Validators.required],
      updatedLName: ['', Validators.required],
      updatedCreatedDate: ['', Validators.required]
    });
  }

  ngAfterViewInit(): void {
    this.fireValidation();
  }

  fireValidation() {
    if (this.action != INAAction.View) {
      if (this.inaStatusTypeId == 1) {
        if (this.fName.errors?.required || this.lName.errors?.required || this.createdDate.errors?.required) {
          this.frmCreatedByFollow.setErrors({ required: true, invalid: 'Complete the followup sections' });
        }
        else {
          this.frmCreatedByFollow.setErrors(null);
        }
      }
      else {
        if (this.updatedFName.errors?.required || this.updatedLName.errors?.required || this.updatedCreatedDate.errors?.required)
          this.frmCreatedByFollow.setErrors({ required: true, invalid: 'Complete the followup sections' });
        else
          this.frmCreatedByFollow.setErrors(null);
      }
      let validator: boolean = (this.frmCreatedByFollow.errors?.['required'] == true) ? false : true;
      this.valid.emit(validator);
    }
  }


  ngOnInit(): void {
    let sectionId: number = 29;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      if (!this.frmCreatedByFollow.dirty) {
        this.setFormValue();
      }
    });

    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });


    this.getQuestions('Comments').forEach(
      (element) => {
        this.commentEditableQuestions.push({ isEdit: false, question: element, isDelete: false });
      }
    )

    if (this.action == 3) {
      this.frmCreatedByFollow.disable();
    }
  }


  setFormValue() {
    this.getListQuestionValueData(493, 'Created by').forEach(
      x => {
        if (x.Name == 'First Name')
          this.fName.setValue(x.Value);
        else if (x.Name == 'Last Name')
          this.lName.setValue(x.Value);
        else if (x.Name == 'Date')
          this.createdDate.setValue(x.Value);
      }
    )
    this.getListQuestionValueData(498, 'Follow-up by').forEach(
      x => {
        if (x.Name == 'First Name')
          this.updatedFName.setValue(x.Value);
        else if (x.Name == 'Last Name')
          this.updatedLName.setValue(x.Value);
        else if (x.Name == 'Date')
          this.updatedCreatedDate.setValue(x.Value);
      }
    )
    this.fireValidation();

  }
  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }

  getListQuestionValueData(questionId: number, questionName: string): LstQuestionValueDataView[] {
    {
      return this.shared.getListQuestionValueData(this.section, questionId, questionName);
    }

  }

  /*setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }
  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
    let s: StepAction = new StepAction();
    s.stepNumber = 12;
    s.action = action == 1 ? '' : this.notifyAction;
    s.section = new Section();
    if (this.frmCreatedByFollow.dirty || this.dataChanged) {
      this.updateChangeValue();
      s.section = this.section;
      s.lsttrackingHistory = this.lstTrackHistory;
      this.lstTrackHistory=[];
      this.dataChanged = false;
    }
    this.prevOrNextStep.emit(s);
  }
    */

  updateChangeValue() {
    if (this.fName.dirty)
      this.setListQuestionValue(493, 'First Name', this.fName.value);

    if (this.lName.dirty)
      this.setListQuestionValue(493, 'Last Name', this.lName.value);

    if (this.createdDate.dirty)
      this.setListQuestionValue(493, 'Date', this.createdDate.value);

    if (this.updatedFName.dirty && this.updatedLName.dirty && this.updatedCreatedDate.dirty)
    {
      this.fireValidation();  
      this.setListQuestionValueGroup(498, 'First Name', this.updatedFName.value);
      this.setListQuestionValueGroup(498, 'Last Name', this.updatedLName.value);            
      this.setListQuestionValueGroup(498, 'Date', this.updatedCreatedDate.value);
          
    }
    else if(this.updatedFName.dirty)
      this.setListQuestionValue(498, 'First Name', this.updatedFName.value);

    else if (this.updatedLName.dirty)
      this.setListQuestionValue(498, 'Last Name', this.updatedLName.value);

    else if (this.updatedCreatedDate.dirty)
      this.setListQuestionValue(498, 'Date', this.updatedCreatedDate.value);

    this.frmCreatedByFollow.markAsPristine();
  }

  addRow(type: string) {
    if (this.editing) {

      this.commentEditableQuestions.findIndex((x) => x.isEdit == true) == -1
        ? (this.commentEditableQuestions = [
          { isEdit: true, isDelete: false, question: this.buildQuestion(type) },
          ...this.commentEditableQuestions
        ])
        : null;

    }
  }
  buildQuestion(matchQuery: string): Question {
    return this.section.Questions.filter(x => x.Name.toString().match(matchQuery)).filter(y => y.lstQuestionValueDataView[0].Value == "")[0]
  }

  getQuestions(matchQuery: string): Question[] {
    return this.section.Questions.filter(x => x.Name.toString().match(matchQuery)).filter(y => y.lstQuestionValueDataView[0].Value != "");
  }


  OperationCUD(action: string) {
    this.dataChanged = true;
    if (action == 'cancelled') {
      this.commentEditableQuestions = this.commentEditableQuestions.filter((g: EditableQuestion) => g.isEdit != true);

    }
    else {
      let questionId: number = Number(action);
      //find updated values using the questionId 
      let updatedEditableQuestion = this.commentEditableQuestions.find(x => x.question.Id == questionId);
      this.section.Questions.forEach(x => {
        if (x.Id == questionId) {
          if (updatedEditableQuestion?.question.lstQuestionValueDataView[0].Value == '') {
            x.lstQuestionValueDataView[0].Value = '';            
            this.commentEditableQuestions = this.commentEditableQuestions.filter((g: EditableQuestion) => g.question.Id != questionId);
            this.setListQuestionValue(questionId,'','')
          }
          else {
            x.lstQuestionValueDataView[0].Value = updatedEditableQuestion?.question.lstQuestionValueDataView[0].Value!;
            this.setListQuestionValue(questionId,'',updatedEditableQuestion?.question.lstQuestionValueDataView[0].Value!)
          }
          
        }
      })

    }
  }
  clearNameDate() {
    if (this.inaStatusTypeId == 1) {
      this.fName.patchValue('');
      this.lName.patchValue('');
      this.createdDate.patchValue('');
      this.fName.markAsDirty();
      this.lName.markAsDirty();
      this.createdDate.markAsDirty();

    }
    else if (this.inaStatusTypeId == 2) {
      this.updatedFName.patchValue('');
      this.updatedLName.patchValue('');
      this.updatedCreatedDate.patchValue('');
      this.updatedFName.markAsDirty();
      this.updatedLName.markAsDirty();
      this.updatedCreatedDate.markAsDirty();
    }
    this.frmCreatedByFollow.markAsDirty();
    this.updateChangeValue();
  }


  populateNameDate() {
    let u: User = this.loginTokenService.getUser();
    if (this.inaStatusTypeId == 1) {
      this.fName.setValue(u?.PERSON?.FIRST_NAME);
      this.lName.setValue(u?.PERSON?.LAST_NAME);
      this.createdDate.setValue(formatDate(new Date(), 'MM/dd/yyyy', 'en'))
      this.fName.markAsDirty();
      this.lName.markAsDirty();
      this.createdDate.markAsDirty();
      this.frmCreatedByFollow.markAsDirty();
      this.updateChangeValue();
    }
    else if (this.inaStatusTypeId == 2) {
      this.updatedFName.patchValue(u?.PERSON?.FIRST_NAME);
      this.updatedLName.patchValue(u?.PERSON?.LAST_NAME);
      this.updatedCreatedDate.patchValue(formatDate(new Date(), 'MM/dd/yyyy', 'en'));
      this.updatedFName.markAsDirty();
      this.updatedLName.markAsDirty();
      this.updatedCreatedDate.markAsDirty();
      this.frmCreatedByFollow.markAsDirty();
      this.updateChangeValue();
    }

  }

  showButton(): boolean {
    if (this.inaStatusTypeId == 2 && (this.action == 1 || this.action == 2)) {
      if (this.frmCreatedByFollow.errors?.['required'])
        return true;
      else
        return false;
    }
    else
      return false;
  }

  /*getQuestionsBackup(matchquery: string): Question[] {
    let sn: Section = new Section();
    sn.SectionName = "CREATED BY & FOLLOW-UP BY";
    sn.SectionID = 29;
    let q: Question[] = [];
    q.push(
      {"Name": "Created by","Id": 493,"lstQuestionValueDataView": [{"Name": "First Name","Value": "Lorena","Type": "TEXT AREA","Id": 1583},
      {"Name": "Last Name","Value": "Gomez","Type": "TEXT AREA","Id": 1584},
      {"Name": "Date","Value": "03/06/2023","Type": "TEXT AREA","Id": 1585},
      {"Name": "I Agree","Value": "True","Type": "TEXT AREA","Id": 1586}]},
      {"Name": "Comments 1","Id": 503,"lstQuestionValueDataView": [{"Name": "Comments 1","Value": "Laks|Thiru|lthiru|2400|test1234567890|08/28/2023 04:13 PM|","Type": "TEXT AREA","Id": 1591}]},
      {"Name": "Comments 2","Id": 504,"lstQuestionValueDataView": [{"Name": "Comments 2","Value": "Laks|Thiru|lthiru|2400|test0987654321|08/28/2023 04:13 PM|","Type": "TEXT AREA","Id": 1592}]},
      {"Name": "Comments 3","Id": 505,"lstQuestionValueDataView": [{"Name": "Comments 3","Value": "","Type": "TEXT AREA","Id": 1593}]},
      {"Name": "Comments 4","Id": 506,"lstQuestionValueDataView": [{"Name": "Comments 4","Value": "","Type": "TEXT AREA","Id": 1594}]},
      {"Name": "Comments 5","Id": 507,"lstQuestionValueDataView": [{"Name": "Comments 5","Value": "","Type": "TEXT AREA","Id": 1595}]},
      {"Name": "Comments 6","Id": 508,"lstQuestionValueDataView": [{"Name": "Comments 6","Value": "","Type": "TEXT AREA","Id": 1596}]},
      {"Name": "Comments 7","Id": 509,"lstQuestionValueDataView": [{"Name": "Comments 7","Value": "","Type": "TEXT AREA","Id": 1597}]},
      {"Name": "Comments 8","Id": 510,"lstQuestionValueDataView": [{"Name": "Comments 8","Value": "","Type": "TEXT AREA","Id": 1598}]},
      {"Name": "Comments 9","Id": 511,"lstQuestionValueDataView": [{"Name": "Comments 9","Value": "","Type": "TEXT AREA","Id": 1599}]},
      {"Name": "Comments 10","Id": 512,"lstQuestionValueDataView":[{"Name": "Comments 10","Value": "","Type": "TEXT AREA","Id": 1600}]}            
    );
    sn.Questions = q;
    let tempRetQuestion = sn.Questions.filter(x => x.Name.toString().match(matchquery)).filter(y => y.lstQuestionValueDataView[0].Value != "");    
    return tempRetQuestion;
  }*/
  setListQuestionValueGroup(questionId: number, questionName: string, value: string) {
      this.shared.setListQuestionValue(this.section, questionId, questionName, value);            
      this.setTrackingHistory(questionId, questionName, value);

    }
  

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
    this.setTrackingHistory(questionId, questionName, value);
    this.fireValidation();
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }

  get fName(): any { return this.frmCreatedByFollow.get('fName'); }
  get lName(): any { return this.frmCreatedByFollow.get('lName'); }
  get createdDate(): any { return this.frmCreatedByFollow.get('createdDate'); }

  get updatedFName(): any { return this.frmCreatedByFollow.get('updatedFName'); }
  get updatedLName(): any { return this.frmCreatedByFollow.get('updatedLName'); }
  get updatedCreatedDate(): any { return this.frmCreatedByFollow.get('updatedCreatedDate'); }
}
